import React from "react";
import {
  IoMailOutline,
  IoLockClosedOutline,
  IoEyeOutline,
  IoEyeOffOutline,
  IoPersonOutline,
  IoCallOutline,
  IoStorefrontOutline,
  IoShieldCheckmarkOutline,
  IoShieldOutline,
  IoDocumentTextOutline,
  IoCardOutline,
  IoCheckmarkCircleOutline,
  IoCheckmarkOutline,
  IoArrowForwardOutline,
  IoHelpCircleOutline,
  IoBagHandleOutline,
  IoStatsChartOutline,
  IoCubeOutline,
  IoSparklesOutline,
  IoTrendingUpOutline,
  IoAlertCircleOutline,
  IoRefreshOutline,
  IoCloseOutline,
  IoChevronForwardOutline,
  IoChevronDownOutline,
  IoNotificationsOutline,
  IoNotifications,
  IoLogOutOutline,
  IoBookOutline,
  IoGridOutline,
  IoAddOutline,
  IoWarningOutline,
  IoOpenOutline,
  IoSearchOutline,
  IoCloudUploadOutline,
  IoCameraOutline,
  IoPhonePortraitOutline,
  IoMenuOutline,
  IoCheckmarkDoneOutline,
  IoFlashOutline,
  IoRocketOutline,
  IoPeopleOutline,
  IoPricetagOutline,
  IoInformationCircleOutline,
  IoPlayCircleOutline,
  IoCheckmarkDoneCircleOutline,
  IoTimeOutline,
  IoCheckboxOutline,
  IoSquareOutline,
  IoCompassOutline,
  IoChatbubbleEllipsesOutline,
  IoLocationOutline,
  IoSyncOutline,
  IoPersonAddOutline,
  IoCashOutline
} from "react-icons/io5";

import {
  MdOutlineLocalShipping,
  MdOutlineVerified,
  MdOutlineAccountBalance,
  MdOutlineCategory
} from "react-icons/md";

// Helper wrapper to accept size, color, className, style
const wrapIcon = (IconComponent) => ({ size = 18, color = "currentColor", className = "", style = {} }) => (
  <IconComponent size={size} color={color} className={className} style={{ verticalAlign: "middle", ...style }} />
);

export const MailIcon = wrapIcon(IoMailOutline);
export const LockIcon = wrapIcon(IoLockClosedOutline);
export const EyeIcon = wrapIcon(IoEyeOutline);
export const EyeOffIcon = wrapIcon(IoEyeOffOutline);
export const UserIcon = wrapIcon(IoPersonOutline);
export const PhoneIcon = wrapIcon(IoCallOutline);
export const StoreIcon = wrapIcon(IoStorefrontOutline);
export const ShieldIcon = wrapIcon(IoShieldOutline);
export const ShieldCheckIcon = wrapIcon(IoShieldCheckmarkOutline);
export const FileTextIcon = wrapIcon(IoDocumentTextOutline);
export const IdCardIcon = wrapIcon(IoCardOutline);
export const ClipboardCheckIcon = wrapIcon(IoCheckmarkDoneOutline);
export const CheckIcon = wrapIcon(IoCheckmarkOutline);
export const CheckCircleIcon = wrapIcon(IoCheckmarkCircleOutline);
export const CheckBadgeIcon = wrapIcon(MdOutlineVerified);
export const ArrowRightIcon = wrapIcon(IoArrowForwardOutline);
export const HelpCircleIcon = wrapIcon(IoHelpCircleOutline);
export const ShoppingBagIcon = wrapIcon(IoBagHandleOutline);
export const ChartIcon = wrapIcon(IoStatsChartOutline);
export const PackageIcon = wrapIcon(IoCubeOutline);
export const SparklesIcon = wrapIcon(IoSparklesOutline);
export const TrendingUpIcon = wrapIcon(IoTrendingUpOutline);
export const AlertCircleIcon = wrapIcon(IoAlertCircleOutline);
export const RefreshIcon = wrapIcon(IoRefreshOutline);
export const XIcon = wrapIcon(IoCloseOutline);
export const ChevronRightIcon = wrapIcon(IoChevronForwardOutline);
export const ChevronDownIcon = wrapIcon(IoChevronDownOutline);
export const LogOutIcon = wrapIcon(IoLogOutOutline);
export const BookOpenIcon = wrapIcon(IoBookOutline);
export const LayoutDashboardIcon = wrapIcon(IoGridOutline);
export const LandmarkIcon = wrapIcon(MdOutlineAccountBalance);
export const WalletCardsIcon = wrapIcon(IoCardOutline);
export const UserCircleIcon = wrapIcon(IoPersonOutline);
export const PlusIcon = wrapIcon(IoAddOutline);
export const AlertTriangleIcon = wrapIcon(IoWarningOutline);
export const ExternalLinkIcon = wrapIcon(IoOpenOutline);
export const SearchIcon = wrapIcon(IoSearchOutline);
export const UploadCloudIcon = wrapIcon(IoCloudUploadOutline);

// Specialized React Native vector icons
export const BellIcon = wrapIcon(IoNotificationsOutline);
export const BellFilledIcon = wrapIcon(IoNotifications);
export const HomeIcon = wrapIcon(IoStorefrontOutline);
export const StorefrontIcon = wrapIcon(IoStorefrontOutline);
export const ShoppingCartIcon = wrapIcon(IoBagHandleOutline);
export const PackageBoxIcon = wrapIcon(IoCubeOutline);
export const GrowthChartIcon = wrapIcon(IoTrendingUpOutline);
export const SparklineChartIcon = wrapIcon(IoStatsChartOutline);
export const UsersGroupIcon = wrapIcon(IoPeopleOutline);
export const CreditCardIcon = wrapIcon(IoCardOutline);
export const TruckIcon = wrapIcon(MdOutlineLocalShipping);
export const BarChart3Icon = wrapIcon(IoStatsChartOutline);
export const HeadphonesIcon = wrapIcon(IoCallOutline);
export const ZapIcon = wrapIcon(IoFlashOutline);
export const RocketIcon = wrapIcon(IoRocketOutline);
export const PlayCircleIcon = wrapIcon(IoPlayCircleOutline);
export const CameraIcon = wrapIcon(IoCameraOutline);
export const MobilePhoneIcon = wrapIcon(IoPhonePortraitOutline);
export const MenuIcon = wrapIcon(IoMenuOutline);
export const TagIcon = wrapIcon(IoPricetagOutline);
export const CategoryIcon = wrapIcon(MdOutlineCategory);
export const CheckDoubleIcon = wrapIcon(IoCheckmarkDoneCircleOutline);
export const InfoIcon = wrapIcon(IoInformationCircleOutline);

// Compatibility aliases
export const DollarSignIcon = wrapIcon(IoCashOutline);
export const ClockTimerIcon = wrapIcon(IoTimeOutline);
export const CheckSquareIcon = wrapIcon(IoCheckboxOutline);
export const SquareIcon = wrapIcon(IoSquareOutline);
export const CompassIcon = wrapIcon(IoCompassOutline);
export const MessageCircleIcon = wrapIcon(IoChatbubbleEllipsesOutline);
export const MapPinIcon = wrapIcon(IoLocationOutline);
export const RefreshCwIcon = wrapIcon(IoSyncOutline);
export const UserPlusIcon = wrapIcon(IoPersonAddOutline);
